export function getClientBaseUrl(): string {
    const { href, hash } = window.location;

    return href.replace(hash, '').replace(/\/$/, '');
}
